module.exports = __webpack_public_path__ + "img/quote.862f4894.svg";